import SearchBreadcrumbs from './SearchBreadcrumbs';

export default SearchBreadcrumbs;
